import React from 'react';
import BrandSection from '../BrandSection/BrandSection';
import { useAppContext } from '../AppContext';

export default function BrandSections(props) {
  const { brands, bodyStyles } = useAppContext();
  const {
    brandFilter,
    selectedYear,
    selectedType,
    onViewInventoryClicked
  } = props;

  const bodyStylesFilteredByType = bodyStyles.filter(
    x => selectedType === '' || x.type === selectedType
  );

  if (brandFilter) {
    const brandBodyStyles = bodyStylesFilteredByType.filter(
      x => x.brand === brandFilter
    );
    return (
      <BrandSection
        bodyStyles={brandBodyStyles}
        brand={brandFilter}
        selectedYear={selectedYear}
        onViewInventoryClicked={onViewInventoryClicked}
      />
    );
  }

  return brands.map(brand => {
    const brandBodyStyles = bodyStylesFilteredByType.filter(
      x => x.brand === brand
    );
    return (
      <BrandSection
        key={brand}
        brand={brand}
        bodyStyles={brandBodyStyles}
        selectedYear={selectedYear}
        onViewInventoryClicked={onViewInventoryClicked}
      />
    );
  });
}
